import { takeLatest, call, put } from 'redux-saga/effects';
import * as accountActions from 'redux/ducks/Employee/AccountDucks';
import * as alertActions from 'redux/ducks/common/alertDucks';
import * as popupActions from 'redux/ducks/common/popupDucks';
import employeeApi from 'api/employee/employeeApi';
import employeeNoSessionApi from 'api/employee/employeeNoSessionApi';
import { PORTAL_MAIN } from 'constants/IncorporationConstants';

export function* getNoSessionRegister() {
  try {
    const response = yield call(employeeApi.getNoSessionRegister, {});
    yield put(accountActions.getNoSessionRegisterSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorMessage] }));
  }
}
export function* getNoSessionGlobalPosition({ payload }) {
  try {
    const response = yield call(employeeApi.getNoSessionGlobalPosition, payload);
    yield put(accountActions.getNoSessionGlobalPositionSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ isDimed: true, message: [error.errorCode] }));
  }
}
export function* getNewEmployee({ payload }) {
  try {
    const response = yield call(employeeApi.getNewEmp, payload);
    yield put(accountActions.getNewEmployeeSuccess(response));
    if (payload.option === 'epOpenCode') yield put(accountActions.checkOtpSuccess(true));
  } catch (error) {
    yield put(alertActions.open({ isDimed: true, message: [error.errorCode] }));
  }
}

export function* checkOtp({ payload }) {
  try {
    const response = yield call(employeeNoSessionApi.checkOtp, payload);
    yield put(accountActions.checkOtpSuccess(response));
  } catch (error) {
    yield put(accountActions.checkOtpFail());
    yield put(alertActions.open({ isDimed: true, message: [error.errorCode] }));
  }
}
export function* updateEmployee({ payload }) {
  try {
    const response = yield call(employeeNoSessionApi.updateEmployee, payload);
    if (response) {
      yield put(
        alertActions.open({
          isDimed: true,
          message: ['MB_M_ID_PROCESS_SUCCESS'],
          callback: () => {
            window.location.href = PORTAL_MAIN;
          },
        }),
      );
    }
    yield put(accountActions.updateEmployeeSuccess(response));
    yield put(popupActions.closeProgressPopup());
  } catch (error) {
    yield put(alertActions.open({ isDimed: true, message: [error.errorCode] }));
    yield put(popupActions.closeProgressPopup());
  }
}

export default function* AccountSaga() {
  yield takeLatest(accountActions.getNoSessionRegister, getNoSessionRegister);
  yield takeLatest(accountActions.getNoSessionGlobalPosition, getNoSessionGlobalPosition);
  yield takeLatest(accountActions.getNewEmployee, getNewEmployee);
  yield takeLatest(accountActions.checkOtp, checkOtp);
  yield takeLatest(accountActions.updateEmployee, updateEmployee);
}
